import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import ContactComplete from '@src/features/company/contact/ContactComplete';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyContactComplete() {
  return (
    <CompanyGuard>
      <CompanyDefaultLayout
        pageName='contact'
        showSidebar={false}
      >
        <CommonHelmet />
        <ContactComplete />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyContactComplete;
